import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const ModalBody = ({ children, className, ...props }) => {
  return (
    <div className={classNames(styles.container, className)} {...props}>
      {children}
    </div>
  );
};

export default ModalBody;
